import React, { useEffect, useState } from "react";
import {
   filterInactiveRooms,
   findMyChatRooms,
   markMessagesAsSeen,
   sortRoomsByLatestMessage,
} from "../../../../ChatScripts";
import { useChat } from "../../../../../../../../context/ChatContext/ChatContext";
import ChatRoomListItem from "../ChatRoomListItem";
import { Empty } from "../../../../../../../BP2Components";
import { useDispatch, useSelector, DefaultRootState } from "react-redux";
import { setChatSettings } from "../../../../../../../../appRedux/actions/ChatSettings";
import { useIntl } from "react-intl";

interface ChatMessagesRoomsListProps {
   oldId: number | null;
}

const ChatMessagesRoomsList: React.FC<ChatMessagesRoomsListProps> = ({ oldId }) => {
   const chatSettings = useSelector((state: DefaultRootState) => state.chatSettings);
   const [selectedRoomId, setSelectedRoomId] = useState<string>("");
   const chatData = useChat();

   const dispatch = useDispatch();

   const intl = useIntl();

   useEffect(() => {
      setSelectedRoomId(chatSettings?.currentRoom?.id || "");
   }, [chatSettings?.currentRoom]);

   if (oldId === null) return <Empty />;

   let messagesFolderRooms = sortRoomsByLatestMessage(
      findMyChatRooms(chatData, oldId),
      chatData?.chatData?.messages,
   );

   const enterChatRoom = (currentRoom) => {
      markMessagesAsSeen(currentRoom, oldId);

      dispatch(
         setChatSettings({
            ...chatSettings,
            currentRoom: currentRoom,
         }),
      );
   };

   const handleMessagesRoomClick = (room) => {
      enterChatRoom(room);
   };

   if (messagesFolderRooms?.length > 0 && oldId) {
      return filterInactiveRooms(messagesFolderRooms)?.map((room) => (
         <ChatRoomListItem
            key={room?.id}
            listType="Messages"
            room={room}
            onClick={handleMessagesRoomClick}
            selectedRoom={selectedRoomId}
         />
      ));
   } else return <Empty description={intl.formatMessage({ id: "chat.noChats" })} />;
};

export default ChatMessagesRoomsList;
